<template>
  <div>
    <div class="diaContainer yauto">
      <!-- 7.合同登记新增表单 -->
      <el-form
        ref="addContractForm1"
        :rules="rules"
        :model="addContractForm"
        v-if="showForm==='showFormContractAdd'"
        label-position="left"
        label-width="160px"
      >
        <div class="diaForm_box">
          <div class="diaFormTitle">项目信息</div>
          <div style="box-sizing:border-box;padding:0 10%">
            <!-- 项目名称 -->
            <el-form-item label="项目名称" v-if="$store.state.process.finance.isFromProjectBar">
              <span
                style="color:#666;font-size:16px;line-height:40px"
              >{{$store.state.process.finance.projectName}}</span>
            </el-form-item>
            <el-form-item label="项目名称" v-else>
             <!-- 在本地搜索 -->
              <!-- <el-select
                style="width:100%"
                v-model="addContractForm.project_id"
                filterable
                @change="handleProjectSelectChange1"
                :disabled="draftDisable"
                multiple
                placeholder="请选择"
              >
                <el-option
                  v-for="(item,num) in projectList"
                  style="max-width: 40vw;"
                  :key="item.project_id"
                  :label="item.project_show"
                  :value="item.project_id"
                ></el-option>
              </el-select> -->

               <!-- 远程搜索 -->
               <el-select
                style="width:100%"
                v-model="addContractForm.project_id"
                filterable
                remote
                multiple
                @change="handleProjectSelectChange1"
                :disabled="draftDisable"
                :filter-method="projectSearch"
                placeholder="请选择"
              >
                <el-option
                  v-for="(item,num) in projectList"
                  style="max-width: 40vw;"
                  :key="item.project_id"
                  :label="item.project_show"
                  :value="item.project_id"
                ></el-option>
              </el-select>



            </el-form-item>
          </div>
        </div>
        <div class="diaForm_box">
          <div class="diaFormTitle">费用信息</div>
          <div style="box-sizing:border-box;padding:0 10%">
            <!-- 申请人 -->
            <el-form-item label="申请人" style="margin-bottom:0px;" v-if="addContractForm.member">
              <span
                v-if="addContractForm.member"
                style="color:#666;font-size:16px"
              >{{addContractForm.member.nickname}}</span>
            </el-form-item>
            <div
              style="font-size:12px;margin-left:160px;color: rgb(245, 95, 95);margin-bottom:20px;margin-top:0px"
            >
              *此项为申请合同操作，请关联项目获取合同编号；表单信息请如实填写，没有合同请填写情况说明表。
              <a
                style="font-size:14px;"
                href="http://control.sxpz.vip/Template/未拿回合同说明.doc"
              >未拿回合同说明表.doc</a>
            </div>

            <!-- 预设审批人 -->
            <el-form-item
              label="预设审批人"
              prop="preset_member"
              style="margin-bottom:30px;"
              v-if="$store.state.process.finance.list3.length>0"
            >
              <el-select
                style="width:100%"
                v-model="addContractForm.preset_member"
                filterable
                :disabled="draftDisable"
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in $store.state.process.finance.list3"
                  style="max-width: 40vw;"
                  :key="item.member_id"
                  :label="item.nickname"
                  :value="item.member_id"
                ></el-option>
              </el-select>
            </el-form-item>
            <!-- 公司/项目名称 -->
            <el-form-item label="公司/项目名称">
              <el-input
                :disabled="draftDisable"
                placeholder="请输入公司/项目名称"
                v-model="addContractForm.business_name"
              ></el-input>
            </el-form-item>
            <!-- 项目类型 -->
            <el-form-item label="项目类型">
              <el-input
                :disabled="draftDisable"
                placeholder="请输入项目类型"
                v-model="addContractForm.project_type"
              ></el-input>
            </el-form-item>
            <!-- 交存人 -->
            <el-form-item label="交存人">
              <el-input
                :disabled="draftDisable"
                placeholder="请输入交存人"
                v-model="addContractForm.manager"
              ></el-input>
            </el-form-item>
            <!-- 存档日期 -->
            <el-form-item label="存档日期">
              <el-date-picker
                :disabled="draftDisable"
                v-model="addContractForm.date"
                type="date"
                style="width:100%"
                placeholder="存档日期"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
            <!-- 合同金额 -->
            <el-form-item label="合同金额">
              <el-input
                :disabled="draftDisable"
                type="number"
                placeholder="请输入合同金额"
                v-model="addContractForm.total"
              ></el-input>
              <div style="width:40px;text-align:center;line-height:40px;">元</div>
            </el-form-item>
            <!-- 首付金额 -->
            <el-form-item label="首付金额">
              <el-input
                :disabled="draftDisable"
                type="number"
                placeholder="请输入首付金额"
                v-model="addContractForm.paid"
              ></el-input>
              <div style="width:40px;text-align:center;line-height:40px;">元</div>
            </el-form-item>
            <!-- 签订日期 -->
            <el-form-item label="签订日期">
              <el-date-picker
                :disabled="draftDisable"
                v-model="addContractForm.date_sign"
                type="date"
                style="width:100%"
                placeholder="签订日期"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>

            <!-- 付款方式 -->
            <el-form-item label="付款方式" style="margin-bottom:0px;">
              <el-input
                :disabled="draftDisable"
                placeholder="按照合同中付款方式描述清楚"
                v-model="addContractForm.pay_type"
              ></el-input>
            </el-form-item>
            <!-- 是否需要评审 -->
            <el-form-item label="是否需要评审" style="margin-bottom:0px;">
              <el-radio-group v-model="addContractForm.is_review" :disabled="draftDisable">
                <el-radio label="1">是</el-radio>
                <el-radio label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <!-- 评审费用 -->
            <el-form-item label="评审费用" style="margin-bottom:0px;">
              <el-radio-group v-model="addContractForm.pay_review_type" :disabled="draftDisable">
                <el-radio label="1">甲方承担</el-radio>
                <el-radio label="2">乙方承担</el-radio>
                <el-radio label="3">甲乙双方共同承担</el-radio>
              </el-radio-group>
            </el-form-item>

            <!-- 备注 -->
            <el-form-item label="备注" style="margin-bottom:20px">
              <el-input
                :disabled="draftDisable"
                placeholder="请输入备注信息"
                type="textarea"
                v-model="addContractForm.remark"
              ></el-input>
            </el-form-item>
            <!-- 附件 -->
            <el-form-item label="附件" style="margin-bottom:20px">
              <upload-file
                style="width:100%"
                :isSubmit="!draftDisable"
                :imgList="this.imgList"
                :detailsImgList="detailsImgList"
                @my-upload-change="upLoadChange"
              ></upload-file>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <!-- 7.合同登记审批表单 -->
      <el-form
        ref="addContractForm2"
        :rules="rules"
        :model="addContractForm"
        v-if="showForm==='showFormContractHandle'"
        label-position="left"
        label-width="160px"
      >
        <div class="diaForm_box diaEditFormBox">
          <div class="ShowFormBtn">
            <el-button
              v-if="addContractForm.withdraw_status=='1'"
              @click="handleFinnaceWithDraw('contract',addContractForm.id)"
              :disabled="disableLimit"
              class="withdrap"
              style="background-color:rgb(255, 26, 26);"
            >撤回</el-button>
            <el-button
              v-if="addContractForm.is_just=='1'"
              @click="handleFinnaceApproveWithDraw('contract',addContractForm.id)"
              :disabled="disableLimit"
              class="withdrap"
              style="background-color:rgb(255, 26, 26);"
            >审批撤回</el-button>
            <el-button
              @click="approveVisible=true"
              v-if="addContractForm.approval_status=='1'"
              class="creat"
              style="background-color:#40A0F2;"
            >去审批</el-button>
          </div>
        </div>
        <div
          class="diaForm_box diaEditFormBox"
          v-if="addContractForm.is_edit=='1' || addContractForm.is_finance_edit=='1' || (addContractForm.project_list && addContractForm.project_list.length>0)"
        >
          <div class="diaFormTitle">项目信息</div>
          <div style="box-sizing:border-box;padding:0 10%">
            <!-- 项目名称 -->
            <el-form-item label="项目名称" v-if="$store.state.process.finance.isFromProjectBar">
              <span
                style="color:#666;font-size:16px;line-height:40px"
              >{{$store.state.process.finance.projectName}}</span>
            </el-form-item>
            <el-form-item label="项目名称" class="containerNoDis" v-else>
              <el-select
                style="width:100%"
                v-model="addContractForm.project_id"
                filterable
                v-if="addContractForm.is_edit=='1'"
                @change="handleProjectSelectChange1"
                :disabled="draftDisable"
                multiple
                placeholder="请选择"
              >
                <el-option
                  v-for="(item,num) in projectList"
                  style="max-width: 40vw;"
                  :key="item.project_id"
                  :label="item.project_show"
                  :value="item.project_id"
                ></el-option>
              </el-select>
              <span
                v-else
                class="projectContainerInbox"
                :key="items.project_id"
                v-for="(items,index) in addContractForm.project_list"
                style="color:#666;font-size:16px;"
              >
                <span
                  class="projectHoverBlue"
                  @click.stop="goProjectDetailsOpenNew(items)"
                  v-if="index<addContractForm.project_list.length-1"
                >{{items.project_name+','}}</span>
                <span
                  class="projectHoverBlue"
                  @click.stop="goProjectDetailsOpenNew(items)"
                  v-else
                >{{items.project_name}}</span>
              </span>
            </el-form-item>
          </div>
        </div>
        <div class="diaForm_box diaEditFormBox">
          <div class="diaFormTitle">费用信息</div>
          <div style="box-sizing:border-box;padding:0 10%">
            <!-- 申请人 -->
            <el-form-item label="申请人" style="margin-bottom:0px;" v-if="addContractForm.member">
              <span
                v-if="addContractForm.member"
                style="color:#666;font-size:16px"
              >{{addContractForm.member.nickname}}</span>
            </el-form-item>
            <div
              style="font-size:12px;margin-left:160px;color: rgb(245, 95, 95);margin-bottom:20px;margin-top:0px"
            >
              *此项为申请合同操作，请关联项目获取合同编号；表单信息请如实填写，没有合同请填写情况说明表。
              <a
                style="font-size:14px;"
                href="http://control.sxpz.vip/Template/未拿回合同说明.doc"
              >未拿回合同说明表.doc</a>
            </div>

            <!-- 预设审批人 -->
            <el-form-item
              label="预设审批人"
              style="margin-bottom:30px;"
              prop="preset_member"
              v-if="addContractForm.is_edit=='1' && $store.state.process.finance.list3.length>0"
            >
              <el-select
                style="width:100%"
                v-model="addContractForm.preset_member"
                filterable
                :disabled="draftDisable"
                clearable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in $store.state.process.finance.list3"
                  style="max-width: 40vw;"
                  :key="item.member_id"
                  :label="item.nickname"
                  :value="item.member_id"
                ></el-option>
              </el-select>
            </el-form-item>

            <!-- 公司/项目名称 -->
            <el-form-item label="公司/项目名称">
              <el-input
                v-if="addContractForm.is_edit=='1' || addContractForm.is_finance_edit=='1'"
                placeholder="请输入公司/项目名称"
                v-model="addContractForm.business_name"
              ></el-input>
              <span v-else style="color:#666;font-size:16px">{{addContractForm.business_name}}</span>
            </el-form-item>
            <!-- 项目类型 -->
            <el-form-item
              label="项目类型"
              v-if="!(addContractForm.is_edit=='1' || addContractForm.is_finance_edit=='1')"
            >
              <el-input
                v-if="addContractForm.is_edit=='1' || addContractForm.is_finance_edit=='1'"
                placeholder="请输入项目类型"
                v-model="addContractForm.project_type"
              ></el-input>
              <span v-else style="color:#666;font-size:16px">{{addContractForm.project_type}}</span>
            </el-form-item>

            <!-- 合同编号 -->
            <el-form-item
              label="合同编号"
              v-if="!(addContractForm.is_edit=='1' || addContractForm.is_finance_edit=='1')"
            >
              <el-input
                v-if="addContractForm.is_edit=='1' || addContractForm.is_finance_edit=='1'"
                placeholder="请输入合同编号"
                v-model="addContractForm.ontract_no"
              ></el-input>
              <span v-else style="color:#666;font-size:16px">{{addContractForm.ontract_no}}</span>
            </el-form-item>
            <!-- 交存人 -->
            <el-form-item label="交存人">
              <el-input
                v-if="addContractForm.is_edit=='1' || addContractForm.is_finance_edit=='1'"
                placeholder="请输入交存人"
                v-model="addContractForm.manager"
              ></el-input>
              <span v-else style="color:#666;font-size:16px">{{addContractForm.manager}}</span>
            </el-form-item>
            <!-- 存档日期 -->
            <el-form-item label="存档日期" style="margin-bottom:10px">
              <el-date-picker
                v-model="addContractForm.date"
                type="date"
                v-if="addContractForm.is_edit=='1' || addContractForm.is_finance_edit=='1'"
                style="width:100%"
                placeholder="存档日期"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
              <span v-else style="color:#666;font-size:16px">{{addContractForm.date}}</span>
            </el-form-item>

            <!-- 付款方式 -->
            <el-form-item label="付款方式" style="margin-bottom:0px;">
              <el-input
                v-if="addContractForm.is_edit=='1' || addContractForm.is_finance_edit=='1'"
                placeholder="按照合同中付款方式描述清楚"
                v-model="addContractForm.pay_type"
              ></el-input>
              <span v-else style="color:#666;font-size:16px">{{addContractForm.pay_type}}</span>
            </el-form-item>
            <!-- 合同金额 -->
            <el-form-item label="合同金额" style="margin-bottom:0px;">
              <el-input
                type="number"
                v-if="addContractForm.is_edit=='1' || addContractForm.is_finance_edit=='1'"
                placeholder="请输入合同金额"
                v-model="addContractForm.total"
              ></el-input>
              <div
                v-if="addContractForm.is_edit=='1' || addContractForm.is_finance_edit=='1'"
                style="width:40px;text-align:center;line-height:40px;"
              >元</div>
              <span v-else style="color:#666;font-size:16px">{{addContractForm.total}}</span>
            </el-form-item>
            <!-- 首付金额 -->
            <el-form-item label="首付金额" style="margin-bottom:0px;">
              <el-input
                type="number"
                v-if="addContractForm.is_edit=='1' || addContractForm.is_finance_edit=='1'"
                placeholder="请输入首付金额"
                v-model="addContractForm.paid"
              ></el-input>
              <div
                v-if="addContractForm.is_edit=='1' || addContractForm.is_finance_edit=='1'"
                style="width:40px;text-align:center;line-height:40px;"
              >元</div>
              <span v-else style="color:#666;font-size:16px">{{addContractForm.paid}}</span>
            </el-form-item>
            <!-- 签订日期 -->
            <el-form-item label="签订日期" style="margin-bottom:10px">
              <el-date-picker
                v-model="addContractForm.date_sign"
                type="date"
                v-if="addContractForm.is_edit=='1' || addContractForm.is_finance_edit=='1'"
                style="width:100%"
                placeholder="签订日期"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
              <span v-else style="color:#666;font-size:16px">{{addContractForm.date_sign}}</span>
            </el-form-item>

            <!-- 是否需要评审 -->
            <el-form-item label="是否需要评审" style="margin-bottom:0px;">
              <el-radio-group
                v-model="addContractForm.is_review"
                v-if="addContractForm.is_edit=='1' || addContractForm.is_finance_edit=='1'"
              >
                <el-radio label="1">是</el-radio>
                <el-radio label="0">否</el-radio>
              </el-radio-group>
              <span v-else style="color:#666;font-size:16px">
                <span v-if="addContractForm.is_review=='1'">是</span>
                <span v-if="addContractForm.is_review=='0'">否</span>
              </span>
            </el-form-item>
            <!-- 评审费用 -->
            <el-form-item label="评审费用" style="margin-bottom:0px;">
              <el-radio-group
                v-model="addContractForm.pay_review_type"
                v-if="addContractForm.is_edit=='1' || addContractForm.is_finance_edit=='1'"
              >
                <el-radio label="1">甲方承担</el-radio>
                <el-radio label="2">乙方承担</el-radio>
                <el-radio label="3">甲乙双方共同承担</el-radio>
              </el-radio-group>
              <span v-else style="color:#666;font-size:16px">
                <span v-if="addContractForm.pay_review_type=='1'">甲方承担</span>
                <span v-if="addContractForm.pay_review_type=='2'">乙方承担</span>
                <span v-if="addContractForm.pay_review_type=='3'">甲乙双方共同承担</span>
              </span>
            </el-form-item>
            <!-- 备注 -->
            <el-form-item label="备注" style="margin-bottom:20px">
              <el-input
                v-if="addContractForm.is_edit=='1' || addContractForm.is_finance_edit=='1'"
                placeholder="请输入备注信息"
                type="textarea"
                v-model="addContractForm.remark"
              ></el-input>
              <el-input
                type="textarea"
                class="onlyShowText"
                disabled
                autosize
                v-else
                v-model="addContractForm.remark"
              ></el-input>
            </el-form-item>

            <!-- 附件 -->
            <el-form-item label="附件" style="margin-bottom:20px">
              <upload-file
                style="width:100%"
                :isSubmit="addContractForm.is_edit=='1' || addContractForm.is_finance_edit=='1'"
                :imgList="this.imgList"
                :detailsImgList="detailsImgList"
                @my-upload-change="upLoadChange"
              ></upload-file>
            </el-form-item>
          </div>
        </div>
        <div class="diaForm_box diaEditFormBox">
          <div class="diaFormTitle">审批信息</div>
          <div style="box-sizing:border-box;padding:0 10%">
            <!-- 已通过 -->
            <el-timeline>
              <el-timeline-item
                v-for="(activity, index) in addContractForm.approval_log"
                :color="activity.approval_status==0?'':'#128bf1'"
                :key="index"
              >
                <div style="margin-bottom:5px">
                  <span>提交人:</span>
                  <span>{{activity.memberInfo.nickname}}</span>
                  <span style="margin:0 10px;color:rgb(18, 139, 241)">提交</span>
                  <span>{{activity.add_time}}</span>
                </div>
                <div>
                  <span
                    v-if="activity.approval_status=='1'"
                    style="margin-right:10px"
                  >{{activity.executorInfo.nickname}}</span>
                  <span v-if="activity.approval_status=='1'" style="color:rgb(18, 139, 241)">通过</span>
                  <span
                    v-if="activity.approval_status=='-1'"
                    style="margin-right:10px"
                  >{{activity.executorInfo.nickname}}</span>
                  <span v-if="activity.approval_status=='-1'" style="color:rgb(255, 51, 51)">驳回</span>
                  <span
                    v-if="activity.approval_status=='-2'"
                    style="margin-right:10px"
                  >{{activity.executorInfo.nickname}}</span>
                  <span v-if="activity.approval_status=='-2'" style="color:rgb(255, 51, 51)">审批撤回</span>
                  <span
                    v-if="activity.approval_status=='0'"
                    v-for="item in activity.tomemberInfo"
                    style="margin-right:10px"
                  >{{item.nickname+' '}}</span>
                  <span v-if="activity.approval_status=='0'" style="color:rgb(255, 51, 51)">待审批</span>
                  <span
                    style="margin-left:10px"
                    v-if="activity.update_time"
                  >{{activity.update_time}}</span>
                </div>
                <div class="remark" style="margin-top:5px" v-if="activity.remark">
                  <span style="margin-right:5px">备注:</span>
                  <span style="color:rgb(255, 51, 51)">{{activity.remark}}</span>
                </div>
              </el-timeline-item>
            </el-timeline>
          </div>
        </div>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <!-- 7合同登记新增按钮 -->
      <el-button
        style="background-color: #ccc;"
        v-if="showForm==='showFormContractAdd' && addContractForm.is_draft!='1'"
        @click="handleAddContractSubmit('1')"
        :disabled="disableLimit"
      >保存草稿</el-button>
      <el-button
        type="primary"
        v-if="showForm==='showFormContractAdd' && addContractForm.is_draft!='1'"
        @click="handleAddContractSubmit('0')"
        :disabled="disableLimit"
      >提 交</el-button>
      <!-- 7合同登记编辑按钮 -->
      <el-button
        style="background-color: #ccc;"
        v-if="showForm==='showFormContractAdd' && addContractForm.is_draft=='1' && !draftDisable"
        @click="handleEditContractSubmit('1')"
        :disabled="disableLimit"
      >保存草稿</el-button>
      <el-button
        type="primary"
        v-if="showForm==='showFormContractAdd' && addContractForm.is_draft=='1' && !draftDisable"
        @click="handleEditContractSubmit('0')"
        :disabled="disableLimit"
      >提 交</el-button>
      <!-- 7合同登记重新提交 -->
      <el-button
        style="background-color: #ccc;"
        v-if="showForm==='showFormContractHandle' && (addContractForm.is_edit=='1' || addContractForm.is_finance_edit=='1')"
        @click="getDialogVisible(false)"
      >取 消</el-button>
      <el-button
        type="primary"
        v-if="showForm==='showFormContractHandle' && (addContractForm.is_edit=='1' || addContractForm.is_finance_edit=='1')"
        @click="handleEditContractSubmit('0')"
        :disabled="disableLimit"
      >提 交</el-button>
    </div>
    <sign-dialog
      @wirtDoen="handleWriteDone"
      :visible.sync="receiverSignFlag"
      @change="handleReceiverSign"
    ></sign-dialog>
    <!-- 弹窗--审批 -->
    <el-dialog
      :visible.sync="approveVisible"
      width="60%"
      class="addClientDia"
      :before-close="approveVisibleClose"
      append-to-body
      @close="approveVisibleClosed"
      :modal-append-to-body="false"
      v-dialogDrag
    >
      <div slot="title" class="header-title">
        <span class="title-age">审批</span>
      </div>
      <div>
        <el-form ref="form" label-position="right" label-width="160px">
          <div class="diaForm_box diaEditFormBox">
            <div
              v-if="addContractForm.approval_status=='1'"
              style="font-size:12px;padding-right:30px;text-align:right;color: rgb(245, 95, 95);margin-bottom:20px;margin-top:0px"
            >*您可以选择驳回后发起人提交的节点</div>
            <!-- 自动审批大通按钮 -->
            <el-form-item label="自动审批" v-if="addContractForm.approval_status=='1'">
              <div style="height:40px;display:flex;align-items:center;">
                <el-switch
                  active-value="1"
                  inactive-value="0"
                  v-model="is_chase"
                  active-color="#128bf1"
                  inactive-color="#ccc"
                ></el-switch>
              </div>
            </el-form-item>
            <el-form-item label="驳回节点" v-if="addContractForm.approval_status=='1'">
              <el-select style="width:95%" v-model="k_code" placeholder="请选择" clearable>
                <el-option
                  style="max-width: 40vw;"
                  v-for="(item,index) in addContractForm.stage_selectArry"
                  :key="item.id"
                  :value="item.id"
                  :label="item.label"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="审批备注" v-if="addContractForm.approval_status=='1'">
              <el-input
                style="width:95%"
                placeholder="审批备注"
                type="textarea"
                v-model="approvalRemark"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="签名"
              v-if="addContractForm.approval_status=='1'"
              style="margin-bottom:20px"
            >
              <img
                v-if="!sign_pic"
                @click="handleReceiverFlag"
                style="width:66px;height:66px;"
                src="../../../assets/image/zaixianqianm@2x.png"
                alt
              />
              <img
                v-if="sign_pic"
                @click="handleReceiverFlag(sign_pic)"
                style="width:66px;height:66px;"
                :src="sign_pic"
                alt
              />
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          @click="handleFinnaceApproval('-1','contract',addContractForm.id)"
          :disabled="disableLimit"
          v-if="addContractForm.approval_status=='1'"
          style="background:#f4a029;"
          class="search"
        >驳回</el-button>
        <el-button
          @click="handleFinnaceApproval('1','contract',addContractForm.id)"
          :disabled="disableLimit"
          v-if="addContractForm.approval_status=='1'"
          class="creat"
          style="background-color:#40A0F2;"
        >通过</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState, mapGetters, mapMutations } from 'vuex'

import TableJson from '../../TableJson'
import UploadFile from '../../../components/UploadFile'
import SignDialog from '../../../components/SignDialog'

import 'viewerjs/dist/viewer.css'
import { api as viewerApi } from 'v-viewer'

export default {
  data() {
    return {
      approveVisible: false,

      sign_pic: '',
      receiverSignFlag: false,
      // 禁用按钮防抖
      disableLimit: false,
      // 弹窗
      imgList: [],
      detailsImgList: [],
      k_code: '',
      token: '',
      member_id: '',
      company_id: '',
      cache_department_id: '',
      // 7.新增合同登记
      addContractForm: {
        pay_type: '',
        is_review: '1',
        pay_review_type: '1',

        is_reg: '0',
        is_bid: '0',
        bid_money: 0,
        is_mark: '0',
        mark_json: '0',
        ontract_no: '',
        business_name: '',
        project_type: '',
        manager: '',
        paid: '',
        date_sign: '',

        project_list: [],
        total: '',
        date: '',
        business_name: '',
        remark: '',
        annex: '',
        project_id: [],
      },
      tiemID1: null,
      timeDou: 100,
      approvalRemark: '',
      // 自动审批大通
      is_chase: '0',
      rules: {
        preset_member: [
          { required: true, message: '请选择预设审批人', trigger: 'change' },
        ],
      },
    }
  },
  props: [],
  components: {
    UploadFile,
    SignDialog,
    TableJson,
  },
  watch: {
    '$store.state.process.finance.formData'(newval, olval) {
      this.addContractForm = newval
    },
    '$store.state.process.finance.dialogVisible'(newval, olval) {
      if (newval == false) {
        this.is_chase = '0'
      }
    },
    'addContractForm.annex': {
      handler: function (val, oldVal) {
        this.imgList = val
        this.detailsImgList = val
      },
    },
    'addContractForm.is_bid': {
      handler: function (val, oldVal) {
        if (val == '0') {
          this.addContractForm.bid_money = 0
        }
      },
    },
    // 默认驳回节点是当前节点
    'addContractForm.stage_selectArry': {
      handler: function (val, oldVal) {
        if (val && val.length > 0) {
          this.k_code = val[val.length - 1].id
        } else {
          this.k_code = ''
        }
      },
    },
  },

  methods: {
// 按搜索条件查找，不在本地进行查找
async projectSearch(val){
   if(!val)return
   console.log(val)
    let param = new FormData()
      param.append('member_id', localStorage.getItem('btlh_process_member_id') || '')
      param.append('token', localStorage.getItem('btlh_process_token') || '')
      
      param.append('cache_department_id', localStorage.getItem('bthl_process_cache_department_id_store') || '')
      param.append('company_id', localStorage.getItem('bthl_process_LoginCompanyId') || '')
     
      param.append('search', val)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Project/simple_project',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      console.log(res.datas.listInfo)
      this.$store.commit(
        'process/finance/assignmentProject',
        res.datas.listInfo
      )
      if (res.datas.listInfo.length > this.moreNum) {
        this.$store.commit(
          'process/finance/setprojectListSub',
          res.datas.listInfo.slice(0, this.moreNum)
        )
      } else {
        this.$store.commit(
          'process/finance/setprojectListSub',
          res.datas.listInfo
        )
      }
      console.log('获取项目列表', this.$store.state.process.finance.projectList)
     
   },


    ...mapMutations('process/finance', ['getDialogVisible']),
    projectFilter(query = '') {
      let arr = this.projectList.filter((item) => {
        return (
          item.project_id.includes(query) || item.project_show.includes(query)
        )
      })
      console.log('arr', arr)
      if (arr.length == 0) {
        this.$forceUpdate()
      }
      if (arr.length > this.moreNum) {
        this.$store.commit(
          'process/finance/setprojectListSub',
          arr.slice(0, this.moreNum)
        )
      } else {
        this.$store.commit('process/finance/setprojectListSub', arr)
      }
    },
    handleProjectSelectBlur1(val) {
      if (!val) {
        if (this.projectList.length > this.moreNum) {
          this.$store.commit(
            'process/finance/setprojectListSub',
            this.projectList.slice(0, this.moreNum)
          )
        } else {
          this.$store.commit(
            'process/finance/setprojectListSub',
            this.projectList
          )
        }

        console.log('this.projectListSub', this.projectListSub)
      }
    },
    handleReceiverFlag(url) {
      this.receiverSignFlag = true
    },
    handleWriteDone(data) {
      this.sign_pic = data
    },
    handleReceiverSign() {},

    // 点击新窗口打开项目页面
    goProjectDetailsOpenNew(items) {
      console.log('items', items)
      // this.$router.resolve({
      //   path: '/project/details/task',
      //   query: {
      //     project_id: items.project_id,
      //     project_name: items.project_name,
      //     isEdit: '1',
      //   },
      // })
      let routeUrl = this.$router.resolve({
        path: '/project/details/task',
        query: {
          project_id: items.project_id,
          project_name: items.project_name,
          isEdit: '1',
          formFinance: '1',
          project_status: '',
        },
      })
      window.open(routeUrl.href)
    },
    upLoadChange(data) {
      this.imgList = data
    },
    // *审批撤回
    async handleFinnaceApproveWithDraw(stage_code, finance_id) {
      this.disableLimit = true
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)

      param.append('finance_id', finance_id)
      param.append('stage_code', stage_code)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Management/finance_approve_withdraw',
        data: param,
      })
      if (res.code != 200) {
        this.disableLimit = false
        return this.$message.error(res.datas.msg)
      }
      this.disableLimit = false
      this.$message.success(res.datas.msg)

      this.getList()
      if (this.$route.path == '/myFlow') {
        this.$store.commit('process/myFlow/get_finnace_coming_list_mutation')
      }
      this.getDialogVisible(false)
    },
    // *撤回
    async handleFinnaceWithDraw(stage_code, finance_id) {
      this.disableLimit = true
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)

      param.append('finance_id', finance_id)
      param.append('stage_code', stage_code)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Finance/withdraw',
        data: param,
      })
      if (res.code != 200) {
        this.disableLimit = false
        return this.$message.error(res.datas.msg)
      }
      this.disableLimit = false
      this.$message.success(res.datas.msg)

      this.getList()
      if (this.$route.path == '/myFlow') {
        this.$store.commit('process/myFlow/get_finnace_coming_list_mutation')
      }
      this.getDialogVisible(false)
    },
    // *财务审批(详情页点击通过或驳回)
    async handleFinnaceApproval(val, stage_code, finance_id) {
      this.disableLimit = true
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('cache_department_id', this.cache_department_id)
      param.append('company_id', this.company_id)

      param.append('finance_id', finance_id)
      param.append('stage_code', stage_code)

      param.append('approval_status', val)
      param.append('remark', this.approvalRemark)
      param.append('k_code', this.k_code)
      param.append('is_chase', this.is_chase)

      param.append('sign_pic', this.sign_pic)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Management/finance_approval',
        data: param,
      })
      if (res.code != 200) {
        this.disableLimit = false
        return this.$message.error(res.datas.msg)
      }
      this.$message.success(res.datas.msg)
      this.disableLimit = false
      // 清空驳回节点
      this.k_code = ''
      this.sign_pic = ''
      this.approvalRemark = ''
      this.getList()
      if (this.$route.path == '/myFlow') {
        this.$store.commit('process/myFlow/get_finnace_coming_list_mutation')
      }
      this.getDialogVisible(false)
      this.approveVisible = false
    },

    // *7编辑合同登记提交
    async handleEditContractSubmit(val) {
      if (this.$store.state.process.finance.list3.length > 0) {
        // 判断是不是草稿
        if (this.addContractForm.is_draft == '1') {
          this.$refs.addContractForm1.validate(async (valid) => {})
        } else {
          this.$refs.addContractForm2.validate(async (valid) => {})
        }
      }

      this.disableLimit = true
      if (this.addContractForm.date == null) {
        this.addContractForm.date = ''
      }
      if (this.addContractForm.date_sign == null) {
        this.addContractForm.date_sign = ''
      }
      clearTimeout(this.tiemID1)
      this.tiemID1 = setTimeout(async () => {
        var strArr = this.tableData
        let param = new FormData()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('is_draft', val)
        param.append('finance_id', this.addContractForm.id)

        param.append('remark', this.addContractForm.remark)
        param.append('annex', JSON.stringify(this.imgList))

        // 多选
        // param.append('project_id', this.addContractForm.project_id.join(','))
        if (this.$store.state.process.finance.isFromProjectBar) {
          param.append(
            'project_id',
            this.$store.state.process.finance.projectId
          )
        } else {
          param.append('project_id', this.addContractForm.project_id.join(','))
        }

        param.append('business_name', this.addContractForm.business_name)
        param.append('project_type', this.addContractForm.project_type)
        param.append('ontract_no', this.addContractForm.ontract_no)
        param.append('manager', this.addContractForm.manager)
        param.append('date', this.addContractForm.date)
        param.append('total', this.addContractForm.total)
        param.append('paid', this.addContractForm.paid)
        param.append('date_sign', this.addContractForm.date_sign)

        param.append('preset_member', this.addContractForm.preset_member)

        param.append('pay_type', this.addContractForm.pay_type)
        param.append('is_review', this.addContractForm.is_review)
        param.append('pay_review_type', this.addContractForm.pay_review_type)

        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Finance/contract_edit',
          data: param,
        })
        if (res.code != 200) {
          this.disableLimit = false
          return this.$message.error(res.datas.msg)
        }
        this.$message.success(res.datas.msg)
        this.disableLimit = false
        this.getList()
        if (this.$route.path == '/myFlow') {
          this.$store.commit('process/myFlow/get_finnace_coming_list_mutation')
        }
        this.getDialogVisible(false)
      }, this.timeDou)
    },
    // *7合同登记新增点击提交
    async handleAddContractSubmit(val) {
      if (this.$store.state.process.finance.list3.length > 0) {
        this.$refs.addContractForm1.validate(async (valid) => {
          //   如果校验失败
          // if (valid == false) return this.$message.error('角色信息不合规')
          // 如果校验成功
        })
      }
      this.disableLimit = true
      if (this.addContractForm.date == null) {
        this.addContractForm.date = ''
      }
      if (this.addContractForm.date_sign == null) {
        this.addContractForm.date_sign = ''
      }
      clearTimeout(this.tiemID1)
      this.tiemID1 = setTimeout(async () => {
        var strArr = this.tableData
        let param = new FormData()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)
        param.append('is_draft', val)

        param.append('remark', this.addContractForm.remark)
        param.append('annex', JSON.stringify(this.imgList))
        // 多选
        // param.append('project_id', this.addContractForm.project_id.join(','))
        // 单选
        // param.append('project_id', this.addContractForm.project_id)
        if (this.$store.state.process.finance.isFromProjectBar) {
          param.append(
            'project_id',
            this.$store.state.process.finance.projectId
          )
        } else {
          param.append('project_id', this.addContractForm.project_id.join(','))
        }

        param.append('business_name', this.addContractForm.business_name)
        param.append('project_type', this.addContractForm.project_type)
        param.append('ontract_no', this.addContractForm.ontract_no)
        param.append('manager', this.addContractForm.manager)
        param.append('date', this.addContractForm.date)
        param.append('total', this.addContractForm.total)
        param.append('paid', this.addContractForm.paid)
        param.append('date_sign', this.addContractForm.date_sign)

        param.append('preset_member', this.addContractForm.preset_member)

        param.append('pay_type', this.addContractForm.pay_type)
        param.append('is_review', this.addContractForm.is_review)
        param.append('pay_review_type', this.addContractForm.pay_review_type)

        // param.append('is_reg', this.addContractForm.is_reg)
        // param.append('is_bid', this.addContractForm.is_bid)
        // param.append('bid_money', this.addContractForm.bid_money)
        // param.append('is_mark', this.addContractForm.is_mark)
        // param.append('mark_json', JSON.stringify(strArr))

        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Finance/contract_add',
          data: param,
        })
        if (res.code != 200) {
          this.disableLimit = false
          return this.$message.error(res.datas.msg)
        }
        this.$message.success(res.datas.msg)
        this.disableLimit = false
        this.getList()
        if (this.$route.path == '/myFlow') {
          this.$store.commit('process/myFlow/get_finnace_coming_list_mutation')
        }
        this.getDialogVisible(false)
      }, this.timeDou)
    },

    getList() {
      if (this.$store.state.process.finance.isFromProjectBar) {
        this.$store.commit(
          'process/finance/getContractList',
          this.$store.state.process.finance.projectId
        )
        this.$store.commit(
          'process/finance/getFinanceSildeBarNum',
          this.$store.state.process.finance.projectId
        )
      } else {
        this.$store.commit('process/finance/getContractList')
      }
    },

    // 选择项目名称1
    async handleProjectSelectChange1(val) {
      if (val && val.length > 1) {
        this.$message.error('关联项目只能选择1个')
        this.addContractForm.project_id = [val[0]]
      }
      // 强制刷新组件
      this.$forceUpdate()
    },
    approveVisibleClose() {
      this.approveVisible = false
    },
    approveVisibleClosed() {
      this.is_chase = '0'
      this.k_code = ''
      this.approvalRemark = ''
      this.sign_pic = ''
    },
  },

  async created() {
    this.addContractForm = JSON.parse(
      JSON.stringify(this.$store.state.process.finance.formData)
    )
    if (this.addContractForm.annex) {
      this.imgList = this.addContractForm.annex
      this.detailsImgList = this.addContractForm.annex
    }
    this.disableLimit = false
    this.token = localStorage.getItem('btlh_process_token') || ''
    this.member_id = localStorage.getItem('btlh_process_member_id') || ''
    // alert(this.member_id)
    this.company_id = localStorage.getItem('bthl_process_LoginCompanyId') || ''
    this.cache_department_id =
      localStorage.getItem('bthl_process_cache_department_id_store') || ''
  },
  mounted() {},
  computed: {
    ...mapState('process/finance', [
      'showForm',
      'draftDisable',
      'formData',
      'moreNum',
      'projectList',
      'projectListSub',
    ]),
  },
}
</script>
<style lang="less" scoped>
@import url(../../../views/topBar/finance.scss);
.search-keyword-more {
  width: 100%;
  text-align: center;
  font-size: 14px;
  color: #999;
}
</style>